import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuthState, useAuth } from './hooks/useAuth'
import { ToastProvider } from './components/ui/Toast'
import { AppLayout } from './components/layout/AppLayout'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { SiteDetailPage } from './pages/SiteDetailPage'
import { AdminPage } from './pages/AdminPage'
import { TeamPage } from './pages/TeamPage'
import { SettingsPage } from './pages/SettingsPage'
import { ViewerPage } from './pages/ViewerPage'
import { GroupViewerPage } from './pages/GroupViewerPage'
import { AnalyticsPage } from './pages/AnalyticsPage'
import { AuditLogPage } from './pages/AuditLogPage'
import { ErrorBoundary } from './components/ui/ErrorBoundary'
import { ChangePasswordModal } from './components/ui/ChangePasswordModal'
import { useToast } from './components/ui/Toast'

function AppRoutes() {
  const auth = useAuthState()

  return (
    <AuthProvider value={auth}>
      <ToastProvider>
        <ForcePasswordChange />
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/sites/:id" element={<SiteDetailPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="rv_admin">
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/team"
              element={
                <ProtectedRoute requiredRole="org_admin">
                  <TeamPage />
                </ProtectedRoute>
              }
            />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route
              path="/audit-log"
              element={
                <ProtectedRoute requiredRole="org_admin">
                  <AuditLogPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Viewers are full-screen, outside AppLayout but still protected */}
          <Route
            path="/sites/:id/viewer"
            element={
              <ProtectedRoute>
                <ViewerPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewer"
            element={
              <ProtectedRoute>
                <GroupViewerPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  )
}

function ForcePasswordChange() {
  const { mustChangePassword, clearMustChangePassword, session } = useAuth()
  const { toast } = useToast()

  if (!session || !mustChangePassword) return null

  return (
    <ChangePasswordModal
      open
      onChanged={() => {
        clearMustChangePassword()
        toast('Password updated successfully', 'success')
      }}
    />
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  )
}
